var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroovesPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 111,
    viewBox: "0 0 452 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.724 110.709L450.496 94.4246L442.626 110.164L381.854 126.448L389.724 110.709Z",
    fill: "#E3E5F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.365 57.0307L594 18.2756L590.124 26.0274L445.489 64.7799L449.365 57.0307Z",
    fill: "#051371"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.409 60.2937L384.514 49.5476L379.32 59.9348L339.216 70.6809L344.409 60.2937Z",
    fill: "#C3C6E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.803 107.384L416.152 67.9019L406.611 86.9834L259.263 126.465L268.803 107.384Z",
    fill: "#EF0808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.204 24.0639L471.799 0.326416L460.326 23.2711L371.731 47.0086L383.204 24.0639Z",
    fill: "#051371"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.798 27.224L508.104 7.5813L504.673 14.4426L431.367 34.0853L434.798 27.224Z",
    fill: "#E3E5F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.582 89.4028L442.594 70.9114L440.745 74.61L371.733 93.1014L373.582 89.4028Z",
    fill: "#051371"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.245 111.994L279.257 93.5024L277.407 97.2011L208.395 115.692L210.245 111.994Z",
    fill: "#C3C6E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroovesPost);
export default __webpack_public_path__ + "static/media/grooves_post.b291ed172ea6b4477f3c7e2ebd7e241a.svg";
export { ForwardRef as ReactComponent };